module.exports = __webpack_public_path__ + "img/ic_qrcode_douyin.427f6e9.png";